import axios from 'axios';
import authHeader from "@/service/auth-header";

class WatchlistService {

    async getUserWatchlists(userId) {
        return await axios.get(`/api/applications/si/watchlist/${userId}`,{ headers: authHeader() })
    }

    async searchWatchlists(userId, exchange, searchCriteria) {
        console.log("[WatchlistService][searchWatchlists] userId = ", userId);
        console.log("[WatchlistService][searchWatchlists] exchange = ", exchange);
        console.log("[WatchlistService][searchWatchlists] searchCriteria = ", searchCriteria);
        return await axios.get(`/api/applications/si/watchlist/search/${userId}/${exchange}/${searchCriteria}`,
            { headers: authHeader() })
    }

    async getWatchlist(id) {
        return await axios.get(`/api/applications/si/watchlist/specific/${id}`,{ headers: authHeader() })
    }

    async createWatchlist(userId, data) {
        return await axios.post(`/api/applications/si/watchlist/${userId}`, data,{ headers: authHeader() });
    }

    async updateWatchlist(id, data) {
        return await axios.put(`/api/applications/si/watchlist/${id}`, data,{ headers: authHeader() });
    }

    async deleteWatchlist(id) {
        return await axios.delete(`/api/applications/si/watchlist/${id}`,{ headers: authHeader() })
    }

}

export default new WatchlistService();
